import { render } from "./VisitDialog.vue?vue&type=template&id=5f57c841&scoped=true"
import script from "./VisitDialog.vue?vue&type=script&lang=js"
export * from "./VisitDialog.vue?vue&type=script&lang=js"

import "./VisitDialog.vue?vue&type=style&index=0&id=5f57c841&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f57c841"]])

export default __exports__